import React, { ChangeEvent, FC, useRef } from "react";

import Button, { ButtonProps } from "@narvar/nth-block-button";

export type FileUploadButtonProps = ButtonProps & {
  accept?: string;
  multiple?: boolean;
  maxSize?: number;
  onChange?: (
    acceptedFiles: File[],
    rejectedFiles: File[],
    event: ChangeEvent<HTMLInputElement>,
  ) => void;
};

const FileUploadButton: FC<FileUploadButtonProps> = ({
  accept,
  multiple,
  maxSize,
  onChange,
  children,
  ...props
}) => {
  const fileInput = useRef<HTMLInputElement>(null);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    const acceptedFiles: File[] = [];
    const rejectedFiles: File[] = [];
    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (maxSize && maxSize > 0 && file.size > maxSize) {
          rejectedFiles.push(file);
          continue;
        }
        acceptedFiles.push(file);
      }
    }
    onChange?.(acceptedFiles, rejectedFiles, event);
  };

  return (
    <>
      <Button onClick={() => fileInput.current?.click()} {...props}>
        {children}
      </Button>
      <input
        ref={fileInput}
        data-testid="file-upload-button__file-input"
        type="file"
        accept={accept}
        multiple={multiple}
        onChange={handleChange}
        style={{ display: "none" }}
      />
    </>
  );
};

export default FileUploadButton;
